import { RestApiClient } from '@engineering11/web-api-rest';

class EventsClient {
    static { this.outgoingEventsPath = 'events/outgoing'; }
    static { this.outgoingEventsEndpointVersion = '1'; }
    constructor(options) {
        const clientOptions = {
            token: options.token,
            baseUrl: options.eventsClientUrl,
            throwNon200s: true, // Since this api is wrapped, 4xx errors should be treated like errors
        };
        this.client = new RestApiClient(clientOptions);
    }
    async sendEvent(data) {
        try {
            await this.sendEventToRestService(data);
        }
        catch (e) {
            return Promise.reject(e);
        }
    }
    sendEventAsync(data) {
        this.sendEventToRestService(data)
            .then((result) => Promise.resolve(result))
            .catch((err) => {
            throw err;
        });
    }
    async sendEventToRestService(data) {
        return this.client.post(EventsClient.outgoingEventsPath, data, { version: EventsClient.outgoingEventsEndpointVersion });
    }
}

/*
 * Public API Surface of events
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EventsClient };
